let menuList = [
  {
    name: 'HOME',
    path: '/menu',
    type: 'in',
    icon: 'https://master-shopvidi.s3.amazonaws.com/brand/menu/menu-home.png',
    key: 'home',
    cpath: 'home/brand-home',
    childrenList: []
  },
  {
    name: 'ORDER',
    path: '#',
    type: 'in',
    redirect: 'Order',
    icon: 'https://master-shopvidi.s3.amazonaws.com/brand/menu/orders.png',
    key: 'Supplier',
    cpath: '',
    childrenList: [
      {
        name: 'Orders',
        path: '/menu',
        type: 'in',
        key: 'Order',
        cpath: 'order/index',
        childrenList: [
          {
            name: 'Create Order',
            key: 'creatOrder',
            path: '/menu',
            type: 'in',
            cpath: 'order/creatOrder'
          },
          {
            name: 'Edit Order',
            key: 'editOrder',
            path: '/menu',
            type: 'in',
            cpath: 'order/editOrder'

          },
          {
            name: 'Order Detail',
            key: 'OrderDetail',
            path: '/menu',
            type: 'in',
            cpath: 'order/orderDetail'

          },
          {
            name: 'Edit Item Avaliability',
            key: 'edit-item-avaliability',
            path: '/menu',
            type: 'in',
            cpath: 'order/edit-item-avaliability'

          },
          {
            name: 'Invoice',
            key: 'invoice',
            path: '/menu',
            type: 'in',
            cpath: 'order/invoice'

          },
          {
            name: 'Store Review',
            key: 'store-review',
            path: '/menu',
            type: 'in',
            cpath: 'order/store-review'
          },
          {
            name: 'Shipping',
            key: 'shipping',
            path: '/menu',
            type: 'in',
            cpath: 'order/shipping'
          },
          {
            name: 'Shipping Invoice',
            key: 'shipping-invoice',
            path: '/menu',
            type: 'in',
            cpath: 'order/shipping-invoice'
          }
        ]
      },

      {
        name: 'Return&Refund',
        path: '/menu',
        type: 'in',
        icon: 'https://shopvidi.oss-cn-beijing.aliyuncs.com/vidirect/v-01.png',
        key: 'service-order',
        cpath: 'order/service-order/service-order-list',
        childrenList: [
          {
            name: 'Service Order Detail',
            path: '/menu',
            type: 'in',
            key: 'service-order-detail',
            cpath: 'order/service-order/service-order-detail',
            childrenList: []
          }
        ]
      }
    ]
  },
  {
    name: 'Marketplace',
    path: '/menu',
    type: 'in',
    icon: 'https://master-shopvidi.s3.amazonaws.com/brand/menu/menu-marketplace.png',
    key: 'Brands',
    cpath: 'brands/index',
    childrenList: []
  },
  {
    name: 'PRODUCT',
    path: '#',
    type: 'in',
    redirect: 'Products',
    icon: 'https://master-shopvidi.s3.amazonaws.com/brand/menu/menu-product.png',
    key: 'vi-direct',
    childrenList: [
      {
        name: 'Products',
        path: '/menu',
        type: 'in',
        key: 'Products',
        cpath: 'produts/index',
        childrenList: [
          {
            name: 'SPU Detail',
            key: 'spuDetails',
            path: '/menu',
            type: 'in',
            cpath: 'spuDetails/index'

          },
          {
            name: 'Wholesale SPU Detail',
            key: 'wholesale-spu-detail',
            path: '/menu',
            type: 'in',
            cpath: 'spuDetails/wholesale-spu-detail'

          },
          {
            name: 'SKU Inventory',
            key: 'sku-inventory',
            path: '/menu',
            type: 'in',
            cpath: 'produts/sku-inventory'

          },
          {
            name: 'Create Spu',
            key: 'CreateSpu',
            path: '/menu',
            type: 'in',
            cpath: 'spuDetails/create-spu'

          }
        ]
      },
      {
        name: 'Images',
        path: '/menu',
        type: 'in',
        key: 'images',
        cpath: 'produts/images-list',
        childrenList: []
      }
    ]
  },
  {
    name: 'CUSTOMER',
    path: '#',
    type: 'in',
    redirect: 'Customers',
    icon: 'https://master-shopvidi.s3.amazonaws.com/brand/menu/menu-customer.png',
    key: 'vi-direct',
    childrenList: [
      // {
      //   name: 'Explore',
      //   path: '/explore',
      //   type: 'in',
      //   key: 'Explore',
      //   cpath: '',
      //   childrenList: [
      //   ]
      // },
      {
        name: 'Customers',
        path: '/menu',
        type: 'in',
        key: 'Customers',
        cpath: '',
        childrenList: [
          {
            name: '',
            key: 'CustomersDetail',
            path: '/menu',
            type: 'in',
            cpath: 'Customers/'

          }
        ]
      },
      {
        name: 'Opportunities',
        path: '/menu',
        type: 'in',
        key: 'Opportunities',
        cpath: '',
        childrenList: [
          {
            name: '',
            key: 'opportunitiesDetail',
            path: '/menu',
            type: 'in',
            cpath: 'Opportunities/'

          }
        ]
      }
    ]
  },
  {
    name: 'VILOCAL',
    path: '#',
    type: 'in',
    redirect: 'ViLocal',
    icon: 'https://s3-amazonaws.shopvidi.com/common/test/2024011617/1742792007971901441/picture-library/f6c8a5c2-3cf1-4e0a-b3f2-2a0588fff167.png',
    key: 'vi-direct',
    childrenList: [
      {
        name: 'Explore',
        path: '/explore',
        type: 'in',
        key: 'Explore',
        cpath: '',
        childrenList: [
        ]
      },
      {
        name: 'Store-based Marketing',
        path: '/store-based-marketing',
        type: 'in',
        key: 'store-based-marketing',
        cpath: '',
        childrenList: [
          {
            name: 'Create',
            key: 'create-store-based-marketing',
            path: '/menu',
            type: 'in',
            cpath: 'store-based-marketing/create-store-based-marketing'
          },
          {
            name: 'Detail',
            key: 'store-based-marketing-detail',
            path: '/menu',
            type: 'in',
            cpath: 'store-based-marketing/store-based-marketing-detail'
          }
        ]
      }
    ]
  },
  // {
  //   name: 'Wholesale Partner',
  //   path: '/menu',
  //   type: 'in',
  //   icon: 'https://shopvidi.oss-cn-beijing.aliyuncs.com/vidirect/v-02.png',
  //   key: 'wholesale-products',
  //   childrenList: [
  //     {
  //       name: 'Procurement Products',
  //       path: '/menu',
  //       type: 'in',
  //       key: 'procurement-products',
  //       childrenList: [
  //         {
  //           name: 'SKU Inventory',
  //           key: 'procurement-sku-inventory',
  //           path: '/menu',
  //           type: 'in'
  //         }
  //       ]
  //     },
  //     {
  //       name: 'Procurement Orders',
  //       path: '/menu',
  //       type: 'in',
  //       key: 'procurement-orders',
  //       childrenList: [
  //         {
  //           name: 'Create Procurement Order',
  //           key: 'procurement-orders-create',
  //           path: '/menu',
  //           type: 'in'
  //         },
  //         {
  //           name: 'Procurement Order Detail',
  //           key: 'procurement-orders-detail',
  //           path: '/menu',
  //           type: 'in'
  //         },
  //         {
  //           name: 'Invoice',
  //           key: 'procurement-orders-invoice',
  //           path: '/menu',
  //           type: 'in'
  //         }
  //       ]
  //     }
  //   ]
  // },
  {
    name: 'ViDirect',
    path: '#',
    type: 'in',
    redirect: 'refer-retailers',
    icon: 'https://master-shopvidi.s3.amazonaws.com/brand/menu/menu-vidirect.png',
    key: 'vi-direct',
    childrenList: [
      {
        name: 'Refer Retailers',
        path: '/menu',
        type: 'in',
        key: 'refer-retailers',
        cpath: 'vidirect/vidirect-list',
        childrenList: []
      },
      {
        name: 'Refer Orders',
        path: '/menu',
        type: 'in',
        key: 'refer-orders',
        cpath: 'vidirect/refer-orders',
        childrenList: [
          {
            name: 'Refer Orders Details',
            path: '/menu',
            type: 'in',
            key: 'refer-orders-detail',
            cpath: 'vidirect/refer-orders-detail',
            childrenList: []
          },
          {
            name: 'Create Refer Orders',
            path: '/menu',
            type: 'in',
            key: 'create-refer-orders',
            cpath: 'vidirect/create-refer-order',
            childrenList: []
          },
          {
            name: 'Wholesale Create Refer Orders',
            path: '/menu',
            type: 'in',
            key: 'wholesale-create-refer-orders',
            cpath: 'vidirect/create-wholesale-refer-order',
            childrenList: []
          }
        ]
      }
    ]
  },
  // {
  //   name: 'Wallet',
  //   path: '/menu',
  //   type: 'in',
  //   icon: 'https://shopvidi.oss-cn-beijing.aliyuncs.com/vidirect/v-06.png',
  //   key: 'Wallet',
  //   childrenList: []
  // },
  {
    name: 'Orders',
    path: '/menu',
    type: 'in',
    icon: 'https://shopvidi.oss-cn-beijing.aliyuncs.com/vidirect/v-01.png',
    key: 'procurement-orders',
    cpath: 'wholesale/procurement-orders',
    childrenList: [

    ]
  },
  {
    name: 'Account Settings',
    path: '/menu',
    type: 'in',
    icon: 'https://master-shopvidi.s3.amazonaws.com/brand/menu/settings.png',
    key: 'business-info',
    cpath: 'business/update-business',
    childrenList: []
  },
  {
    name: 'Help Center',
    path: 'https://help.shopvidi.com/en/collections/4298316-for-brands',
    type: 'out',
    icon: 'https://master-shopvidi.s3.amazonaws.com/brand/menu/help-center.png',
    childrenList: []
  }

]

export default {
  menuList
}



// WEBPACK FOOTER //
// ./src/pages/components/menu-config.js